<template>
  <div>
    <div class="row justify-content-center">
    </div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <horizontal-stepper
              :steps="demoSteps"
              @completed-step="completeStep"
              @active-step="isStepActive"
              @stepper-finished="alert"
              locale="es"
            ></horizontal-stepper>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HorizontalStepper from "vue-stepper";
import DatosPersonales from "./FormSecundarioExamenSteps/DatosPersonales.vue";
import DatosDomicilio from "./FormSecundarioExamenSteps/DatosDomicilio.vue";
import DatosContacto from "./FormSecundarioExamenSteps/DatosContacto.vue";
import DatosDocumentos from "./FormSecundarioExamenSteps/DatosDocumentos.vue";

export default {
  components: {
    HorizontalStepper,
    DatosPersonales,
    DatosDomicilio,
    DatosContacto,
    DatosDocumentos,
  },
  data() {
    return {
      demoSteps: [
        {
          icon: "person",
          name: "first",
          title: "Paso 1",
          subtitle: "Datos personales",
          component: DatosPersonales,
          completed: false,
        },
        {
          icon: "location_on",
          name: "second",
          title: "Paso 2",
          subtitle: "Datos de domicilio",
          component: DatosDomicilio,
          completed: false,
        },
        {
          icon: "email",
          name: "second",
          title: "Paso 3",
          subtitle: "Datos de contacto",
          component: DatosContacto,
          completed: false,
        },
        {
          icon: "attach_file",
          name: "second",
          title: "Paso 4",
          subtitle: "Carga de documentos",
          component: DatosDocumentos,
          completed: false,
        },
      ],
    };
  },
  methods: {
    // Executed when @completed-step event is triggered
    completeStep(payload) {
      this.demoSteps.forEach((step) => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.demoSteps.forEach((step) => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    // Executed when @stepper-finished event is triggered
    alert(payload) {
      alert("end");
    },
  },
};
</script>